export default {"src":"/_next/static/media/sos.8481cc2c.svg","height":111,"width":111,"blurWidth":0,"blurHeight":0};